import * as React from "react";

function SvgHeart(props) {
  return <svg width={12} height={10} viewBox="0 0 12 10" fill="none" {...props}><path d="M6 10L5.12988 9.29138C2.03994 6.73026 0 5.06797 0 2.99727C0 1.30784 1.43994 0 3.3 0C4.34997 0 5.33991 0.43599 6 1.14445C6.66006 0.43599 7.64997 0 8.7 0C10.5601 0 12 1.30784 12 2.99727C12 5.06799 9.96003 6.73029 6.87012 9.29138L6 10Z" fill="currentColor" /></svg>;
}

export default "//cdn.scentbird.com/assets/frontbird-site/images/heart_a647e1.svg";
export { SvgHeart as ReactComponent };